import { atom } from "jotai";
import { Buffer } from "buffer";
import { handleErrors } from "../logic/handleErrors";
import { User } from "../core/User";
import { addMessageAtom } from "datasheets/components/UserCommunicationsToast";

export const userAtom = atom<User | null>(null);
userAtom.onMount = (setAtom) => {
  fetch("/login/resume")
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        return null;
      }
    })
    .then((json) => {
      if (json) {
        setAtom(json);
      }
    })
    .catch(handleErrors);
};
const auth = async (username: string, password: string) => {
  const res = await fetch("/login", {
    method: "GET",
    headers: {
      Authorization:
        "Basic " + Buffer.from(username + ":" + password).toString("base64"),
    },
  });
  if (res.ok) {
    return res.json();
  } else {
    return null;
  }
};

export const loginAtom = atom(
  null,
  (get, set, { username, password, setModalIsOpen }) => {
    auth(username, password)
      .then((json) => {
        if (json != null) {
          set(userAtom, json);
          setModalIsOpen(false);
        } else {
          set(addMessageAtom, "Login failed");
          set(logoutAtom, null);
        }
      })
      .catch((err) => {
        set(addMessageAtom, "Login failed");
        handleErrors(err);
      });
  }
);

export const logoutAtom = atom(null, (get, set, _) => {
  set(userAtom, null);
  fetch("/logout").catch(handleErrors);
});

export const updateUserFullNameAtom = atom(
  (get) => get(userAtom)?.name,
  (get, set, name) => {
    const option = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "PUT",
      body: JSON.stringify({ name: name }),
    };
    fetch("/user/name", option)
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error("Could not update username");
        }
      })
      .then((user) => set(userAtom, user))
      .catch((err) => console.log(err)); //TODO: Better error handling
  }
);

export const updateUserPasswordAtom = atom(
  null,
  (get, set, { newPassword, currentPassword }) => {
    const option = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "PUT",
      body: JSON.stringify({
        newPassword: newPassword,
        currentPassword: currentPassword,
      }),
    };
    fetch("/user/password", option).catch(handleErrors);
  }
);

export const testUserAtom = {
  id: 1,
  name: "Bob Dobson",
  username: "beardiface",
  isAdmin: false,
};
